import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export { default as Breadcrumb } from './Breadcrumb.vue';
export { default as BreadcrumbEllipsis } from './BreadcrumbEllipsis.vue';
export { default as BreadcrumbItem } from './BreadcrumbItem.vue';
export { default as BreadcrumbItemWrapper } from './BreadcrumbItemWrapper.vue';
export { default as BreadcrumbLink } from './BreadcrumbLink.vue';
export { default as BreadcrumbList } from './BreadcrumbList.vue';
export { default as BreadcrumbMobileDropdownMenu } from './BreadcrumbMobileDropdownMenu.vue';
export { default as BreadcrumbPage } from './BreadcrumbPage.vue';
export { default as BreadcrumbSeparator } from './BreadcrumbSeparator.vue';
export { default as BreadcrumbWrapper } from './BreadcrumbWrapper.vue';

export interface BreadcrumbItem {
	label: string;
	route: RouteLocationRaw;
	type?: 'home' | 'macroregion' | 'region' | 'city' | 'street' | 'state';
	separator?: boolean;
}

export interface BreadcrumbProps {
	class?: HTMLAttributes['class'];
	items: BreadcrumbItem[];
	isLoading?: boolean;
}

export interface BreadcrumbItemWithIndex extends BreadcrumbItem {
	index: number;
}

export interface BreadcrumbEmits {
	(e: 'breadcrumb-clicked', payload: BreadcrumbItem): void;
}

export interface BreadcrumbWrapperProps {
	class?: HTMLAttributes['class'];
}

export interface BreadcrumbEllipsisProps {
	class?: HTMLAttributes['class'];
}

export interface BreadcrumbItemProps {
	class?: HTMLAttributes['class'];
}

export interface BreadcrumbLinkProps extends PrimitiveProps {
	class?: HTMLAttributes['class'];
	to?: RouteLocationRaw | null;
}

export interface BreadcrumbListProps {
	class?: HTMLAttributes['class'];
}

export interface BreadcrumbPageProps {
	class?: HTMLAttributes['class'];
}

export interface BreadcrumbSeparatorProps {
	class?: HTMLAttributes['class'];
}

export interface BreadcrumbMobileDropdownMenuProps {
	class?: HTMLAttributes['class'];
	items: BreadcrumbItem[];
}

export function isFirstItem(index: number) {
	return index === 0;
}
export function isLastItem(index: number, items: BreadcrumbItem[]) {
	return index === items.length - 1;
}

export function isFirstOrLastItem(index: number, items: BreadcrumbItem[]) {
	return isFirstItem(index) || isLastItem(index, items);
}
